import { useSetRecoilState } from 'recoil'
import { IFaqArticleSearchTag } from '../../../../../../../../faq.types'
import articleSearchTagsAtom from '../../../../../../searchTags.atom'
import faqAtom from '../../../../../../../../faq.atom'
import confirmServiceCtrl from '../../../../../../../../../../../services/ConfirmService/confirmService.ctrl'
import textUtils from '../../../../../../../../../../../utils/text.utils'
import faqApi from '../../../../../../../../faq.api'
import eventBus from '../../../../../../../../../../../services/eventBus'
import Button from '../../../../../../../../../../../shared/Buttons/Button/Button'

interface IProps {
  selected: IFaqArticleSearchTag[]
}

const ArticleSearchTagsDeleteBtn = (props: IProps) => {
  const setArticleSearchTagsState = useSetRecoilState(articleSearchTagsAtom)
  const setFaqState = useSetRecoilState(faqAtom)

  const handleDelete = () => {
    confirmServiceCtrl
      .requestConfirm({
        title: 'Удаление поисковых тегов',
        description: `Подтвердите удаление ${props.selected.length} ${textUtils.declineWordDependingOnCount(
          props.selected.length,
          ['тега', 'тега', 'тегов']
        )}`,
        type: 'danger',
      })
      .then((r) => {
        if (r.response === 'confirm') {
          faqApi.deleteArticleSearchTags(props.selected.map((tag) => tag.id)).then((r) => {
            if (r.status === 'success') {
              setArticleSearchTagsState((prev) => ({
                ...prev,
                filters: { ...prev.filters, forceReload: prev.filters.forceReload + 1 },
              }))
              setFaqState((prev) => ({ ...prev, loaded: false }))
              eventBus.pub('ntf.message', { message: 'Поисковые теги удалены', type: 'info' })
            }
          })
        }
      })
  }

  if (!props.selected.length) {
    return null
  }

  return (
    <Button theme='danger' style={{ textAlign: 'left' }} onClick={handleDelete}>
      <div className='inline-flex-gap' style={{ gap: '10px' }}>
        <div
          style={{
            color: '#fff',
            width: 21,
            height: 21,
            borderRadius: 10,
            backgroundColor: 'var(--alert)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {props.selected.length}
        </div>
        <span>Удалить</span>
      </div>
    </Button>
  )
}

export default ArticleSearchTagsDeleteBtn
